import {
  ChangeDetectionStrategy,
  Component, ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  Output, QueryList,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { ITableActionOutput, ITableColumn, ITableRow, ITableRowMeta, ITableSortOutput } from '@interfaces/common/table.interface';
import {TableColumnComponent} from '@components/common/table/table-column/table-column.component';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TableComponent implements OnChanges {
  @Output()
  public rowClicked: EventEmitter<ITableRow> = new EventEmitter<ITableRow>();

  @Output()
  public actionClicked: EventEmitter<ITableActionOutput> = new EventEmitter<ITableActionOutput>();

  @Output()
  public sorted: EventEmitter<ITableSortOutput> = new EventEmitter<ITableSortOutput>();

  @Input()
  public columns: ITableColumn[] = [];

  @Input()
  public rows?: ITableRow[] = [];

 @Input()
  public rowMeta: ITableRowMeta[] = [];

  @Input()
  public sortKey = '';

  @Input() headerVisible = true;

  @Input() rowBgEven = true;


  @Input()
  public sortDirection: 'desc' | 'asc' = 'asc';

   @Input() expandRowTemplate!: TemplateRef<any>;

  @ContentChildren(TableColumnComponent)
  public set columnTemplates(columnTemplates: QueryList<TableColumnComponent>) {
    // eslint-disable-next-line no-underscore-dangle
    this._columnTemplates = columnTemplates;
    columnTemplates.forEach((e) => {
      // eslint-disable-next-line no-underscore-dangle
      this._columnTemplatesObject[e.key] = e;
    });
  }

   expandedRowIndex: number | null = null;

  public get columnTemplates(): QueryList<TableColumnComponent> {
    // eslint-disable-next-line no-underscore-dangle
    return this._columnTemplates;
  }

  public get columnTemplatesObject(): { [key: string]: TableColumnComponent } {
    // eslint-disable-next-line no-underscore-dangle
    return this._columnTemplatesObject;
  }

  protected _columnTemplates!: QueryList<TableColumnComponent>;

  protected _columnTemplatesObject: { [key: string]: TableColumnComponent } = {};

  public ngOnChanges(): void {
    // this.loadPage();
  }

  public headerClick(column: ITableColumn): void {
    if (column.sortable) {
      if (this.sortKey === column.key) {
        if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc';
        } else {
          this.sortKey = '';
          this.sortDirection = 'asc';
        }
      } else {
        this.sortDirection = 'asc';
        this.sortKey = column.key;
      }
      this.sorted.emit({
        sortKey: this.sortKey,
        sortDirection: this.sortDirection
      });
    }
  }

  public rowClick(row: ITableRow, column: ITableColumn): void {
    if (column.isAction) {
      this.actionClicked.emit({
        data: row,
        action: column.key
      });
    } else {
      this.rowClicked.emit(row);
    }
  }

    toggleRow(index: number, event: MouseEvent): void {
    // Check if the click came from a dropdown button
  if ((event as any).isDropdownClicks) {
    return; // Don't expand if it was a dropdown click
  }

  const isExpandable = this.rowMeta[index]?.expandable;
  if (!isExpandable) return;

  this.expandedRowIndex = this.expandedRowIndex === index ? null : index;

  }

}
